import { Check, Gem, Hourglass, ShieldCheck, Target } from "lucide-react";
import { deckStrength, GATES, gateBroken, gateDue, gatePassed, gateStacks, getRecord, progressSummary } from "../../engine";
import type { VirtueId } from "../../engine";
import { useGame } from "../../state/GameProvider";

const VIRTUES: Array<{ id: VirtueId; glyph: string }> = [
  { id: "ren", glyph: "仁" },
  { id: "li", glyph: "禮" },
  { id: "zhi", glyph: "智" },
  { id: "xin", glyph: "信" },
  { id: "yong", glyph: "勇" },
];

export function VirtueRail() {
  const { state } = useGame();
  const strength = deckStrength(state.progress);
  const record = getRecord(state.progress, state.duel.analectId);
  const summary = progressSummary(state.progress);

  return (
    <section className="panel virtue-panel">
      <div className="panel-title">
        <Gem size={15} />
        德 · 牌組強度
        <strong>{strength}</strong>
      </div>
      <div className="virtue-grid">
        {VIRTUES.map((virtue) => (
          <div key={virtue.id} className={`virtue-gem v-${virtue.id}`} title={`${virtue.glyph}：${state.progress.virtues[virtue.id]}`}>
            <span className="vg-glyph">{virtue.glyph}</span>
            <span className="vg-val">{state.progress.virtues[virtue.id]}</span>
          </div>
        ))}
      </div>
      <div className="mastery-mini">
        <div className="mastery-title">
          <ShieldCheck size={14} />
          本則精通
          <strong>{`${GATES.filter((gate) => gateBroken(state.duel, gate.id)).length}/4`}</strong>
        </div>
        {GATES.map((gate) => {
          const broken = gateBroken(state.duel, gate.id);
          const due = !broken && gatePassed(record.gates[gate.id]) && gateDue(record.gates[gate.id]);
          const stacks = gateStacks(state.duel, gate.id);
          const label = broken
            ? "已破"
            : due
              ? "待複習"
              : stacks > 0
                ? `${stacks}/${gate.requirement}`
                : `${gate.buffLabel}≥${gate.requirement}`;
          return (
            <div key={gate.id} className={`ladder-row compact tone-${gate.id}${broken ? " done" : ""}${due ? " due" : ""}`}>
              <span className="lr-glyph" aria-hidden>
                {gate.glyph}
              </span>
              <span className="lr-body">
                <strong>{gate.label}</strong>
                <small>{gate.reward}成就 · {gate.description}</small>
              </span>
              <span className="lr-state">
                {broken ? <Check size={14} /> : due ? <Hourglass size={13} /> : <Target size={13} />}
                {/* Translators replace text nodes. Keep a stable element next
                    to the changing icon so React can insert it after a win. */}
                <span>{label}</span>
              </span>
            </div>
          );
        })}
        <div className="clear-cond compact">
          <span>全書門關</span>
          <strong>
            {`${summary.gates}/${summary.totalGates}`}
          </strong>
          <i className="meter">
            <b style={{ width: `${summary.percent}%` }} />
          </i>
        </div>
      </div>
    </section>
  );
}
